import { CqrsService } from '@common/services/cqrs.service';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '@common/services/common.service';
import { ViewMode } from '@common/models/view-mode';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { subDays } from 'date-fns';
import { DialogService } from '@services/dialog.service';

@Component({
    selector: 'app-vessel-visit-create',
    templateUrl: './vessel-visit-create.component.html',
    styleUrls: ['./vessel-visit-create.component.scss'],
})
export class VesselVisitCreateComponent implements OnInit {

    model: any = {};
    sourceIds: string[];

    cargoAgentOptions: any[] = [];

    isBusy = false;
    faSpinner = faSpinner;

    etdDisabledDates = (date: Date) => date <= subDays(new Date(this.model.eta), 1);
    
    constructor(
        public activeModal: NgbActiveModal, 
        private cqrs: CqrsService,
        protected common: CommonService,
        private toastrService: ToastrService,
        protected translateService: TranslateService,
        private dialogService: DialogService,
    ) { }

    async confirm() {   
        try{       
            this.isBusy = true;          
            this.model.movements = [];            
            
            var data = {
                TerminalOperatorId: this.model.terminalOperatorId,
                VesselId: this.model.vesselId,
                ETA: this.model.eta,
                ETD: this.model.etd
            }

            const overlaps = await this.cqrs.query(`VesselVisitOverlaps`, data) as any;               
            
            if(overlaps){
                const result = await this.dialogService.confirm(
                    this.translateService.instant('Vessel Visit overlap') as string, 
                    this.translateService.instant(`An existing vessel visit has been identified for the selected vessel and terminal operator that overlaps with the specified period.
                        
                        Do you want to continue anyway?`) as string,
                    false,
                    this.translateService.instant('Confirm') as string,
                    this.translateService.instant('Cancel') as string,
                    {width:600, height: 300}
                )

                if(result){
                    const vesselVisit = await this.cqrs.command(`SaveVesselVisit`, { saveModel: this.model, action: ViewMode.create}) as any;               
                    this.activeModal.close(vesselVisit);                        
                }
            } else {
                const vesselVisit = await this.cqrs.command(`SaveVesselVisit`, { saveModel: this.model, action: ViewMode.create}) as any;               
                this.activeModal.close(vesselVisit);    
            }        
        } catch (err) {
            this.toastrService.error('Error saving data');            
        } finally {
            this.isBusy = false;
        }
    }

    async ngOnInit() {        
        const { results: allOrganizations } = await this.common.cqrs.query('Organizations', { take: 1000, permissionFilter: false }) as any;
        const mapToCodelist = (orgs: any[]) => orgs.map(({ id: value, name: label }) => ({ value, label }));
        
        this.cargoAgentOptions = mapToCodelist(allOrganizations.filter(org => org.typeId === 'AGN')); // cargo agents            
    }

    get isValid(): boolean {
        return !this.model.vesselId ||
            !this.model.terminalOperatorId ||
            !this.model.eta ||
            !this.model.etd ||
            !this.model.callPurposeId ||
            !this.model.pilotId ||
            !this.model.arrivalAgentId ||
            !this.model.departureAgentId;
    }
}
